import React, { Fragment,useState } from 'react'
import { ViewDetailsDialog } from './ViewDetailsDialog';
import PurchaseMixDialog from './PurchaseMixDialog';
import RejectVoucherDialog from './RejectVoucherDialog';
import { Tooltip } from '@mui/material';
import { MdContentPasteSearch, MdDoDisturbAlt } from 'react-icons/md';
import { FiDollarSign } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import reportService from '../../../services/reportService';
import { setToastMessage } from '../../../reducers/common.reducer';

const ButtonGroup = (props) => {
    const {
      data,
      teamCount,
      fetchData,
      isMobile=false
    } = props;

    const dispatch = useDispatch();
    const [openView, setOpenView] = useState(false);
    const [openPurchase, setOpenPurchase] = useState(false);
    const [openReject, setOpenReject] = useState(false);
    const [selectedId, setSelectedId] = useState(0);
    const [selectedVoucher, setSelectedVoucher] = useState("");
    const [saveLoading, setSaveLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detailsData, setDetailsData] = useState([]);

 const handleSave = async (amount, remark, func) => {
        try {
            setSaveLoading(true);
            const payload = {
                gamblingTypeId: 2,
                gamblingId: selectedId,
                remark,
                teamCount,
                VoucherNo: selectedVoucher,
                betAmount: Number(amount)
            }

            const response = await reportService.purchaseVoucher(payload);

            if (response.status === 200) {
                func();
                dispatch(setToastMessage({ type: "success", message: 'Successfully inserted' }));
                setOpenPurchase(false);
                fetchData();
            }
            else {
                dispatch(setToastMessage({ type: "error", message: response.data.message }));
            }
        }
        catch (error) {
            console.log("error>>>", error.message);
        }
        finally {
            setSaveLoading(false);
        }
    }

    const handleViewDetails = async(id, voucher) => {
        setSelectedId(id);
        setSelectedVoucher(voucher);
        setOpenView(true);
        await fetchDetailsData(id);
    }

    const handlePurchase = (id, voucher) => {
        setSelectedId(id);
        setSelectedVoucher(voucher);
        setOpenPurchase(true);
    }

    const fetchDetailsData = async (id) => {
        try {
            setLoading(true);
            const response = await reportService.reportByMixDetailsVoucer(id);

            if (response.status === 200) {
                setDetailsData(response?.data.viewDetails);
            }
        }
        catch (error) {
            console.log("error", error);
        }
        finally {
            setLoading(false);
        }
    }

  return (
     <Fragment>
            <ViewDetailsDialog open={openView} setOpen={setOpenView} detailsData={detailsData} loading={loading} isMobile={isMobile}/>
            <PurchaseMixDialog open={openPurchase} setOpen={setOpenPurchase} handleSave={handleSave} saveLoading={saveLoading} isMobile={isMobile} />
            <RejectVoucherDialog open={openReject} setOpen={setOpenReject} isMobile={isMobile}/>
          {
              isMobile ?
                  <div className='flex justify-around items-center'>
                      {
                        data?.status === "Active" &&
                          <button className='text-white text-xs mt-2 bg-customFontGreen px-2 py-1 rounded-sm flex items-center gap-1'
                              onClick={() => handlePurchase(data.gamblingId, data.postingNo)}
                          >
                              <FiDollarSign className="text-sm" aria-label="Purchase" /> Purchase
                          </button>
                      }
                      <button className='text-white text-xs mt-2 bg-customFontVoilet px-2 py-1 rounded-sm flex items-center gap-1'
                      onClick={() => handleViewDetails(data.gamblingId, data.postingNo)}
                      >
                          <MdContentPasteSearch className="text-sm" aria-label="View details" /> View Details 
                      </button>
                      {
                          data?.status === "Active" &&
                          <button className='text-white text-xs mt-2 bg-customFontRed px-2 py-1 rounded-sm flex items-center gap-1'
                              onClick={() => setOpenReject(true)}
                          >
                              <MdDoDisturbAlt className="text-sm" aria-label="Cancel" />Reject
                          </button>
                      }
                  </div>
                  :
                  <div className="flex justify-evenly items-center w-[90%]" >
                      {
                          data?.status === "Active" &&
                          <Tooltip title="Purchase" placement="top" arrow>
                              <span onClick={() => handlePurchase(data.gamblingId, data.postingNo)}>
                                  <FiDollarSign className="text-[22px] text-customFontGreen" aria-label="Purchase" />
                              </span>
                          </Tooltip>
                      }
                      <Tooltip title="View Details" placement="top" arrow>
                          <span onClick={() => handleViewDetails(data.gamblingId, data.postingNo)}>
                              <MdContentPasteSearch className="text-[22px] text-customFontVoilet" aria-label="View details" />
                          </span>
                      </Tooltip>
                      {
                          data?.status === "Active" &&
                          <Tooltip title="Reject" placement="top" arrow>
                              <span onClick={() => setOpenReject(true)}>
                                  <MdDoDisturbAlt className="text-[22px] text-customFontRed" aria-label="Cancel" />
                              </span>
                          </Tooltip>
                      }
                  </div>
          }
        </Fragment>
  )
}

export default ButtonGroup
